import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CustomNavLink = makeShortcode("CustomNavLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <CustomNavLink link='#teaching' body='Teaching' mdxType="CustomNavLink" />
    <CustomNavLink link='#research' body='Research' mdxType="CustomNavLink" />
    <CustomNavLink link='https://www.math.toronto.edu/smt/cv.pdf' body='Resume' newTab={true} mdxType="CustomNavLink" />
    <CustomNavLink link='https://www.google.com' body='Another Link' newTab={true} mdxType="CustomNavLink" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      